import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getBrandId } from '../../helpers/getBrandId/getBrandId';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { QueryKeys } from '../QueryKeys';
import { EProductLibraryStatus } from '../../api/getProductLibrarySyncStatus/getProductLibrarySyncStatus';
import { rejectSync } from 'src/api/rejectSync/rejectSync';
import { IProductLibraryStatus } from '../useProductLibraryStatus/useProductLibraryStatus';

export const useRejectSync = () => {
  const syncQueryKey = [getBrandId(), QueryKeys.librarySyncStatus];
  const queryClient = useQueryClient();
  const { showSnackbar } = useSnackbar();

  const mutation = useMutation({
    mutationFn: async () => rejectSync(),
    onMutate: async () => {
      await queryClient.cancelQueries({ queryKey: syncQueryKey });

      queryClient.setQueryData(syncQueryKey, (old: IProductLibraryStatus) => ({
        ...old,
        sync_status: EProductLibraryStatus.REJECTED,
      }));
    },
    onError: (error: unknown) => {
      showSnackbar({
        status: SnackbarStatus.ERROR,
        message: error instanceof Error ? error.message : 'Failed to reject sync',
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [getBrandId(), QueryKeys.notifications] });
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: syncQueryKey });
    },
  });

  return {
    rejectSync: mutation.mutate,
  };
};
